<template>
  <div class="players" role="radiogroup" :aria-label="label">
    <button
      v-for="player in players"
      :key="player.id"
      type="button"
      role="radio"
      class="player-option"
      :aria-checked="selectedId === player.id"
      @click="emit('select', player.id)"
    >
      <span class="radio" aria-hidden="true"></span>
      <span class="name">{{ player.name }}</span>
      <span
        v-if="pointsFor(player.id) !== null"
        class="points"
        :class="{ 'is-negative': pointsFor(player.id) < 0 }"
      >
        {{ formatPoints(pointsFor(player.id)) }}
      </span>
    </button>
  </div>
</template>

<script setup>
import { formatPoints } from '../utils/scores';

defineProps({
  players: {
    type: Array,
    required: true
  },
  selectedId: {
    type: String,
    default: null
  },
  label: {
    type: String,
    required: true
  },
  pointsFor: {
    type: Function,
    required: true
  }
});

const emit = defineEmits(['select']);
</script>

<style scoped>
.players {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.player-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 52px;
  padding: 0 1rem;
  border-radius: var(--radius-control);
  border: 1px solid var(--card-line);
  background-color: var(--control);
  color: var(--ink);
  text-align: left;
  font-weight: 500;
  transition:
    border-color 0.15s,
    background-color 0.15s;
}

.player-option:hover {
  border-color: var(--ink-muted);
}

.player-option[aria-checked='true'] {
  border-color: var(--strong);
  box-shadow: inset 0 0 0 1px var(--strong);
}

.radio {
  flex: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--ink-muted);
  transition: border-width 0.15s;
}

[aria-checked='true'] .radio {
  border: 6px solid var(--strong);
}

.name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.points {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--ink-muted);
}

.points.is-negative {
  color: var(--red);
}
</style>
